import { render, staticRenderFns } from "./EditionTranslations.vue?vue&type=template&id=b5901e12"
import script from "./EditionTranslations.vue?vue&type=script&lang=js"
export * from "./EditionTranslations.vue?vue&type=script&lang=js"
import style0 from "./EditionTranslations.vue?vue&type=style&index=0&id=b5901e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports